__turbopack_context__.v({
  "participantList": "ParticipantList-module__eUfWBq__participantList",
  "participantListContainer": "ParticipantList-module__eUfWBq__participantListContainer",
  "participantList__text": "ParticipantList-module__eUfWBq__participantList__text",
});
